// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"QuickCartButton_cartButton__e1532","subTotal":"QuickCartButton_subTotal__a13c2","badge":"QuickCartButton_badge__3b2ff"};